let context_path = $("#mainScript").data('context_path');

let etica = {
    init: function () {
        this.main.init();
    },
    slider: {
        card_info: undefined
    },
    main: {
        init: function () {
            this.foundation();
            this.header();
            this.login();
            this.footable();
            this.floatLabels();
            this.form();
            this.graph();
            this.slider();
            this.exportFunction();
            this.showMore();
            this.countdown();
            this.addToCalendar();
            this.certifiedDomanis();
            this.snackbar();
            this.utenzeClienti();
            this.utenzeCollocatori();
            this.profilePage();
            this.contatti();
            this.iscrittiEventiLive();
            this.iscrittiSingoloEventoLive();
            this.exportExcel();
            this.showPicPacDateContracts();
            this.controlloPdfAnnuali();
            this.checkIE11();
            this.detectIEEdge();
            this.mailchimp();
            this.homepageModal();
        },
        mailchimp: function() {
            // TODO: far partire le chiamate di atterraggio alle pagine DASHBOARD, ELENCO RAPPORTI E PROFILO
            if($('.no-call-mailchimp').length === 0) {
                if($('#reports').length > 0 || $('.profilo-page').length > 0 || $('.homepage-cliente').length > 0 || $('.homepage-collocatore').length > 0 || $('.rapporti-cliente').length > 0) {
                    
                    const fromUrl = window.location.pathname;
                    
                    $.ajax({
                        url: context_path + '/.rest/api/mailchimp/v1/getMemberInfo?fromUrl='+fromUrl,
                        type: "GET",
                        data: null,
                        success: function(res){
                            if($('.profilo-page').length > 0){
                                let privacyA = res.pvcA;
                                let privacyB = res.pvcB;
                                $('#privacyA').prop('checked', privacyA);
                                $('#privacyB').prop('checked', privacyB);
                            }
                        },
                        error: function(err) {
                            console.log("error get info",err);
                            if(err.status === 500) {
                                const listPrivacy = {
                                    fromUrl: window.location.pathname
                                };
                                $.ajax({
                                    url: context_path + '/.rest/api/mailchimp/v1/addOrUpdateMember',
                                    type: "PUT",
                                    data: JSON.stringify(listPrivacy),
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "json",
                                    success: function(res){
                                    },
                                    error: function(error) {
                                        console.log("error add/update info",error);
                                    }
                                });
                            }
                        }
                    });
                } 
                if($('.landing-perfezionamento').length > 0 || $('.landing-perfezionamento-popso').length > 0) {
					const listPrivacy = {
                        fromUrl: window.location.pathname
                    };
                    $.ajax({
                        url: context_path + '/.rest/api/mailchimp/v1/addOrUpdateMember',
                        type: "PUT",
                        data: JSON.stringify(listPrivacy),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                        },
                        error: function(error) {
                            console.log("error add/update info",error);
                        }
                    });
				}

                if($('.landing-registrazione').length > 0) {
					const keycloakID = $('.landing-registrazione').text();
                    $.ajax({
                        url: context_path + '/.rest/api/mailchimp/v1/addNewMember',
                        type: "PUT",
                        data: keycloakID,
                        success: function(res){
                        },
                        error: function(error) {
                            console.log("error add/update info",error);
                        }
                    });
                }
            }
        },
        detectIEEdge: function () {
            let ua = window.navigator.userAgent;

            let msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            let trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                let rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }
            // other browser
            return false;
        },
        checkIE11: function () {
            if(this.detectIEEdge()) {
                if($('.etica-table-ajax.rapporti').length > 0 || $('.etica-table-ajax.clienti').length > 0 || $(".login-wrapper").length > 0 || $(".form-contatti").length > 0){
                    $('#modaleCIE11').foundation('open');
                }
            }
        },
        controlloPdfAnnuali: function () {
            $('.confirmCheckPdf').on('click',function(evt) {
                evt.preventDefault();
                $('#modaleConfermaPdfAnnuale').foundation('close');
                $('.overlay-container').removeClass('hide-overlay-container');
                let nomeFileOriginale = $(this).data('document');
                let page = window.location.href;
				let pageWithoutParams = getPathFromUrl(page);
                let body = {}
                body["nomeFileOriginale"] = nomeFileOriginale;
                $.ajax({
                    url: context_path + '/.rest/api/data/v1/confermaPdfAnnuale',
                    type:'POST',
                    data: JSON.stringify(body),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function(){
                        $('.overlay-container').addClass('hide-overlay-container');
                        window.location.href = pageWithoutParams+'?success_publish';
                    },
                    error: function(err) {
                        $('.overlay-container').addClass('hide-overlay-container');
                        window.location.href = pageWithoutParams+'?error_publish';
                    }
                });
            });
            
            $('.rejectCheckPdf').on('click',function(evt) {
                evt.preventDefault();
                $('#modaleScartaPdfAnnuale').foundation('close');
                $('.overlay-container').removeClass('hide-overlay-container');
                let nomeFileOriginale = $(this).data('document');
                let page = window.location.href;
				let pageWithoutParams = getPathFromUrl(page);
                let body = {}
                body["nomeFileOriginale"] = nomeFileOriginale;
                $.ajax({
                    url: context_path + '/.rest/api/data/v1/scartaPdfAnnuale',
                    type:'POST',
                    data: JSON.stringify(body),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function(){
                        $('.overlay-container').addClass('hide-overlay-container');
                        window.location.href = pageWithoutParams+'?success_reject';
                    },
                    error: function(err) {
                        $('.overlay-container').addClass('hide-overlay-container');
                        window.location.href = pageWithoutParams+'?error_reject';
                    }
                });
            });

            $('.openModalConfirmPdf').on('click',function() {
                let idDocument = $(this).data('document');
                $('.idDocument').html('');
                $('.idDocument').html(idDocument);
                $('.confirmCheckPdf').data('document', '');
                $('.confirmCheckPdf').data('document', idDocument);
                $('#modaleConfermaPdfAnnuale').foundation('open');
            });

            $('.openModalRejectPdf').on('click',function() {
                let idDocument = $(this).data('document');
                $('.idDocument').html('');
                $('.idDocument').html(idDocument);
                $('.rejectCheckPdf').data('document','');
                $('.rejectCheckPdf').data('document', idDocument);
                $('#modaleScartaPdfAnnuale').foundation('open');
            });


            if($('.snackbar').length > 0 && $('.container-pdf-annuali').length > 0) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if(urlParams.has('success_publish') || urlParams.has('success_reject')){
                    $('.snackbar-success-edit').removeClass('hidden');
                    setTimeout( () => {
                        $('.snackbar-success-edit').addClass('active');
                    },300);
                    setTimeout(() => {
                        $('.snackbar-success-edit').removeClass('active');
                        setTimeout(() => {
                            $('.snackbar-success-edit').addClass('hidden');
                        }, 500);
                    }, 5000);
                }

                if(urlParams.has('error_publish') || urlParams.has('error_reject')){
                    $('.snackbar-error-edit').removeClass('hidden');
                    setTimeout( () => {
                        $('.snackbar-error-edit').addClass('active');
                    },300);
                    setTimeout(() => {
                        $('.snackbar-error-edit').removeClass('active');
                        setTimeout(() => {
                            $('.snackbar-error-edit').addClass('hidden');
                        }, 500);
                    }, 5000);
                }
                if(urlParams.has('success_publish')){
                    $('.snackbar-success-edit .successText').html("Pdf confermato e pubblicato con successo!");
                } else if(urlParams.has('success_reject')){
                    $('.snackbar-success-edit .successText').html("Pdf scartato con successo!");
                } else if(urlParams.has('error_publish')){
                    $('.snackbar-error-edit .errorText').html("Errore di sistema, contattare l'amministratore...");
                } else if(urlParams.has('error_reject')){
                    $('.snackbar-error-edit .errorText').html("Errore di sistema, contattare l'amministratore...");
                }else {
                }
            }

            function getPathFromUrl(url) {
                return url.split(/[?#]/)[0];
            }
        },
        showPicPacDateContracts: function () {
            // SHOW AND HIDE PIC AND PAC DATE
            if($("#tab-pac-title").length > 0 || $("#tab-pic-title").length > 0){
                $("#tab-pac-title").on("click", function (){
                    if($(".pac-date").length > 0){
                        $(".pac-date").addClass("active");
                    }
                    if($(".pic-date").length > 0){
                        $(".pic-date").removeClass("active");
                    }
                });
                $("#tab-pic-title").on("click", function (){
                    if($(".pac-date").length > 0){
                        $(".pac-date").removeClass("active");
                    }
                    if($(".pic-date").length > 0){
                        $(".pic-date").addClass("active");
                    }
                });
            }
        },
        exportExcel: function () {
            $(".export").on('click',function(evt) {
                evt.preventDefault();
                if(!$(this).is(':disabled')){
                    $(this).find(".icon-excel").remove();
                    $(this).prepend("<span class='fonticon icon-load'></span>");
                    $(this).attr("disabled", true);
                    $(this).addClass("disabled");
                    let linkDataExport = $(this).data('link');
                    downloadFile(linkDataExport);
                }
            });

            $(".exportAbi").on('click', function(evt) {
                evt.preventDefault();

                if(!$(this).is(':disabled')){
                    $(this).find(".icon-excel").remove();
                    $(this).prepend("<span class='fonticon icon-load'></span>");
                    $(this).attr("disabled", true);
                    $(this).addClass("disabled");

                    let linkDataExport = $(this).data('link');
                    let abi = $('#abi-select').length > 0 ? $('#abi-select').val() : $('[name=filter_abi]').text();
                    let cab = $('#cab-select').length > 0 ? $('#cab-select').val() : $('[name=filter_cab]').text();
                    let saldo = $('#saldo-select').val();
                    let saldoZero = null, saldoPositivo = null;

                    if (saldo === "Solo saldo 0,00 €") {
                        saldoZero = true;
                    } else if (saldo === "Escludi saldo 0,00 €") {
                        saldoPositivo = true;
                    }

                    downloadFile(linkDataExport+"?abi="+abi+"&cab="+cab+"&saldoZero="+saldoZero+"&saldoPositivo="+saldoPositivo);
                }
            });

            

            function downloadFile(urlToSend) {
                let req = new XMLHttpRequest();
                req.open("GET", urlToSend, true);
                req.responseType = "blob";
                req.onload = function (event) {
                    let blob = req.response;
                    let fileName = "";
                    let disposition = req.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        let matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) { 
                            fileName = matches[1].replace(/['"]/g, '');
                        }
                    }
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    if($('.export').length > 0){
                        $(".export").attr("disabled", false);
                        $(".export").removeClass("disabled");
                        $(".icon-load").remove();
                        $(".export").prepend("<span class='fonticon icon-excel'></span>");
                    }
                    if($('.exportAbi').length > 0){
                        $(".exportAbi").attr("disabled", false);
                        $(".exportAbi").removeClass("disabled");
                        $(".icon-load").remove();
                        $(".exportAbi").prepend("<span class='fonticon icon-excel'></span>");
                    }
                };
                req.send();
            }
        },
        iscrittiSingoloEventoLive: function () {
            $('[name=filter_search_iscritti_singolo_evento]').on('keyup paste', _.debounce(function(e){
                let iconClear = $(this).parent().find('.input-filter-clear');
                let alpha = e.type == 'keyup' && !FooTable.is.emptyString(String.fromCharCode(e.charCode)),
                    ctrl = e.type == 'keyup' && (e.which == 8 || e.which == 46), // backspace & delete
                    paste = e.type == 'paste'; 
                if(alpha || ctrl || paste) {
                    if (e.which == 13) e.preventDefault();
                    let query = e.target.value;
                    let filtering = FooTable.get('.etica-table-iscritti-singolo-evento').use(FooTable.Filtering);
                    if (query.length >= 3){
                        filtering.addFilter('search', query);
                        filtering.filter();
                        iconClear.addClass('show');
                        $('.btn-reset-filters-iscritti-singolo-evento').prop('disabled', false);
                        
                    } else {
                        filtering.removeFilter('search');
                        filtering.filter();
                        if(e.which == 8 && query.length < 3) {
                            e.target.value = '';
                        }
                        iconClear.removeClass('show');
                    }
                }
            }, 300));

            // Clear term searched
            $('[name=filter_search_iscritti_singolo_evento] + .input-filter-clear').on('click', function(){
                
                let filtering = FooTable.get('.etica-table-iscritti-singolo-evento').use(FooTable.Filtering);
                filtering.removeFilter('search');
                filtering.filter();
                $('[name=filter_search_iscritti_singolo_evento]').val('');
                $(this).removeClass('show');
            });

            // Reset filters
            $('.btn-reset-filters-iscritti-singolo-evento').on('click', function(){
                resetFiltersIscrittiSingoloEvento();
                $(this).prop('disabled', true);
            });


            function resetFiltersIscrittiSingoloEvento() {
                let filter = $('.section-filter'),
                    filterSearch = $('.section-filter-search'),
                    iconClear = $('.input-filter-clear'),
                    filtering = FooTable.get('.etica-table-iscritti-singolo-evento').use(FooTable.Filtering);

                if(filterSearch.find('[name=filter_search_iscritti_singolo_evento]').length > 0) {
                    filterSearch.find('[name=filter_search_iscritti_singolo_evento]').val('');
                    filtering.removeFilter('search');
                    if(iconClear.length > 0){
                        iconClear.removeClass('show');
                    }
                }

                filtering.filter();
            }
        },
        iscrittiEventiLive: function () {
            $('[name=filter_search_eventi]').on('keyup paste', _.debounce(function(e){
                let iconClear = $(this).parent().find('.input-filter-clear');
                let alpha = e.type == 'keyup' && !FooTable.is.emptyString(String.fromCharCode(e.charCode)),
                    ctrl = e.type == 'keyup' && (e.which == 8 || e.which == 46), // backspace & delete
                    paste = e.type == 'paste'; 
                if(alpha || ctrl || paste) {
                    if (e.which == 13) e.preventDefault();
                    let query = e.target.value;
                    let filtering = FooTable.get('.etica-table-eventi').use(FooTable.Filtering);
                    if (query.length >= 3){
                        filtering.addFilter('search', query);
                        filtering.filter();
                        iconClear.addClass('show');
                        $('.btn-reset-filters-eventi').prop('disabled', false);
                        
                    } else {
                        filtering.removeFilter('search');
                        filtering.filter();
                        if(e.which == 8 && query.length < 3) {
                            e.target.value = '';
                        }
                        iconClear.removeClass('show');
                    }
                }
            }, 300));

            // Clear term searched
            $('[name=filter_search_eventi] + .input-filter-clear').on('click', function(){
                
                let filtering = FooTable.get('.etica-table-eventi').use(FooTable.Filtering);
                filtering.removeFilter('search');
                filtering.filter();
                $('[name=filter_search_eventi]').val('');
                $(this).removeClass('show');
            });


            $('[name=evento_filter_eventi]').on('change', function(){
                let filtering = FooTable.get('.etica-table-eventi').use(FooTable.Filtering);
                    filter = $(this).val();
                if (filter === 'none'){
                    filtering.removeFilter('evento');
                } else {
                    filtering.addFilter('evento', filter, ['evento']);
                }
                $('.btn-reset-filters-eventi').prop('disabled', false);
                filtering.filter();
            });

            // Reset filters
            $('.btn-reset-filters-eventi').on('click', function(){
                resetFiltersListaEventi();
                $(this).prop('disabled', true);
            });


            function resetFiltersListaEventi() {
                let filter = $('.section-filter'),
                    filterSearch = $('.section-filter-search'),
                    iconClear = $('.input-filter-clear'),
                    filtering = FooTable.get('.etica-table-eventi').use(FooTable.Filtering);

                if(filter.find('[name=evento_filter_eventi]').length > 0) {
                    let valStatus = filter.find('[name=evento_filter_eventi] option:first-child').val();
                    filter.find('[name=evento_filter_eventi]').val(valStatus);
                    filtering.removeFilter('evento');
                }
                if(filterSearch.find('[name=filter_search_eventi]').length > 0) {
                    filterSearch.find('[name=filter_search_eventi]').val('');
                    filtering.removeFilter('search');
                    if(iconClear.length > 0){
                        iconClear.removeClass('show');
                    }
                }

                filtering.filter();
            }
        },
        contatti: function () {
            if($(".snackbar").length > 0) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if(urlParams.has('success_create')){
                    $(".snackbar-success-create").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-create").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-create").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-create").addClass("hidden");
                        }, 500);
                    }, 5000);
                }

                if(urlParams.has('error_create')){
                    $(".snackbar-error-create").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-error-create").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-error-create").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-error-create").addClass("hidden");
                        }, 500);
                    }, 5000);
                }
            }

            $(".close-snackbar").on("click", function () {
                $(".snackbar").removeClass("active");
                setTimeout(function () {
                    $(".snackbar").addClass("hidden");
                }, 500);
            });

        	//submit mail contatti
            if(!this.detectIEEdge()) {
                //console.log("click form contatti - NON IE11");
                $( "#form-contatto-altro-soggetto" ).on("submit", async function (evt)  {

                    evt.preventDefault();
                    let urlApi = context_path + '/.rest/api/data/v1/sendMail';               	    
                    let body = {};

                    let $inputs = $('#form-contatto-altro-soggetto .generatedFileds');
                    let fields = {}
                    let x = 0;
                    let stop = false;
                    $inputs.each(function() {
                        fields[x] = this.name + ": " + $(this).val();
                        if($(this).prop("required") && ($(this).val() == "" || $(this).val() == null)) {
                            stop = true;
                        }
                        x++;
                    });
                    let request = $( "#form-contatto-altro-soggetto select[name='richiesta-contatto']" ).val();
                    let requestBody = $( "#form-contatto-altro-soggetto textarea[name='testo']" ).val();
                    let mailTo = $( "#form-contatto-altro-soggetto input[name='mailTo']" ).val();
                    let mailFrom = $( "#form-contatto-altro-soggetto input[name='mailFrom']" ).val();
                    let filePath = $( "#form-contatto-altro-soggetto #file" ).val();
                    
                    if(request == null || requestBody == null || mailTo == null || mailFrom == null || stop) {
                        return;
                    }
                    
                    let fileName = getFileName(filePath);    
                    
                    if(fileName) {
                        let file = $('#file')[0].files[0];
                        body["file"] = await toBase64(file);
                    }
                    
                    body["request"] = request;
                    body["requestBody"] = requestBody;
                    body["fields"] = fields;
                    body["mailTo"] = mailTo;
                    body["mailFrom"] = mailFrom;
                    body["fileName"] = fileName;
                                    
                    let page = window.location.href;
                    const index = window.location.href.indexOf("?");
                    if(index > 0) {
                        page = page.substring(0, index);
                    }
                    
                    $.ajax({
                        url:urlApi,
                        type:"POST",
                        data:JSON.stringify(body),
                        contentType:"application/json; charset=utf-8",
                        dataType:"json",

                        success: function(res){
                            window.location.href = page+"?success_create";
                        },
                        error: function(err) {
                            window.location.href = page+"?error_create";
                        }
                    });
                });
            } else {
                //console.log("click form contatti - SI IE11");
                // FOR IE11
                $( "#form-contatto-altro-soggetto" ).on("submit", function (evt)  {

                    evt.preventDefault();
                    let urlApi = context_path + '/.rest/api/data/v1/sendMail';               	    
                    let body = {};

                    let $inputs = $('#form-contatto-altro-soggetto .generatedFileds');
                    let fields = {}
                    let x = 0;
                    let stop = false;
                    $inputs.each(function() {
                        fields[x] = this.name + ": " + $(this).val();
                        if($(this).prop("required") && ($(this).val() == "" || $(this).val() == null)) {
                            stop = true;
                        }
                        x++;
                    });
                    let request = $( "#form-contatto-altro-soggetto select[name='richiesta-contatto']" ).val();
                    let requestBody = $( "#form-contatto-altro-soggetto textarea[name='testo']" ).val();
                    let mailTo = $( "#form-contatto-altro-soggetto input[name='mailTo']" ).val();
                    let mailFrom = $( "#form-contatto-altro-soggetto input[name='mailFrom']" ).val();
                    let filePath = $( "#form-contatto-altro-soggetto #file" ).val();
                    
                    if(request == null || requestBody == null || mailTo == null || mailFrom == null || stop) {
                        return;
                    }
                    
                    let fileName = getFileName(filePath);    
                    
                    if(fileName) {
                        let file = $('#file')[0].files[0];
                        body["file"] = toBase64(file);
                    }

                    setTimeout( function () {
                        body["request"] = request;
                        body["requestBody"] = requestBody;
                        body["fields"] = fields;
                        body["mailTo"] = mailTo;
                        body["mailFrom"] = mailFrom;
                        body["fileName"] = fileName;
                                        
                        let page = window.location.href;
                        const index = window.location.href.indexOf("?");
                        if(index > 0) {
                            page = page.substring(0, index);
                        }
                        
                        $.ajax({
                            url:urlApi,
                            type:"POST",
                            data:JSON.stringify(body),
                            contentType:"application/json; charset=utf-8",
                            dataType:"json",

                            success: function(res){
                                window.location.href = page+"?success_create";
                            },
                            error: function(err) {
                                window.location.href = page+"?error_create";
                            }
                        });
                    },3000);
                    
                });
            }

            function getFileName(fullPath) {
                let fileName = null
                if (fullPath) {
                    let startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
                    fileName = fullPath.substring(startIndex);
                    if (fileName.indexOf('\\') === 0 || fileName.indexOf('/') === 0) {
                        fileName = fileName.substring(1);
                    }
                }
                return fileName;
            }

            function toBase64(file) { 
                return new Promise( function(resolve,reject) {
                    const reader= new FileReader()
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        return resolve(reader.result);
                    };
                    reader.onerror = function (error) {
                        return reject(error);
                    };
                });
            };
        },
        
        utenzeCollocatori: function () {

            if($(".snackbar").length > 0 && $(".etica-table-collocatori").length > 0) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if(urlParams.has('success_update')){
                    $(".snackbar-success-update").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-update").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-update").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-update").addClass("hidden");
                        }, 500);
                    }, 5000);
                }

                if(urlParams.has('success_delete')){
                    $(".snackbar-success-delete").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-delete").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-delete").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-delete").addClass("hidden");
                        }, 500);
                    }, 5000);
                }
            }

            $("#tipologia_collocatore").on("change", function () {
                $(".text-collocatore").addClass("hidden");
                if($(this).val() === "etica-collocatore-plus"){
                    $(".collocatorePlus").removeClass("hidden");
                    $(".collocatoreBasic").addClass("hidden");
                } else {
                    $(".collocatoreBasic").removeClass("hidden");
                    $(".collocatorePlus").addClass("hidden");
                }
            });

            $(".close-snackbar").on("click", function () {
                $(".snackbar").removeClass("active");
                setTimeout(function () {
                    $(".snackbar").addClass("hidden");
                }, 500);
            });

            // BUTTON CANCELLAZIONE UTENTE
            $("#deleteCollocatore").on("click", function (e) {

                let paginaUtenzeCollocatori =  $("#form-modifica-collocatore input[name='paginaCollocatori']").val();
                let userId= $(this).data("userid");

                $.ajax({
                    url: context_path + '/.rest/api/data/v1/deleteClient?userId='+userId,
                    type:"DELETE",
                    success: function(res){
                        window.location.href = paginaUtenzeCollocatori+"?success_delete";
                        return false;
                    },
                    error: function(err) {
                        $('#responseUpdateUtenzaCollocatore .title-response-modal').html('Errore!');
                        $('#responseUpdateUtenzaCollocatore .text-response-modal').html(err.responseJSON.message);
                        $('#responseUpdateUtenzaCollocatore').foundation('open');
                        return false;
                    }
                });
                return false;
            });

            // FORM DI UPDATE UTENZA COLLOCATORE
            $("#form-modifica-collocatore").on("submit", function (e) {
                if (!e.isDefaultPrevented()) {

                    let paginaUtenzeCollocatori =  $("#form-modifica-collocatore input[name='paginaCollocatori']").val();
                    let userId =  $("#form-modifica-collocatore input[name='userId']").val();
                    let abi =  $("#form-modifica-collocatore input[name='abi']").val();
                    let cab =  $("#form-modifica-collocatore input[name='cab']").val();
                    let tipologia =  $("#form-modifica-collocatore select[name='tipologia']").val();

                    let datalist = {
                        "userId": userId,
                        "tipologia": tipologia,
                        "abi": abi,
                        "cab":cab
                    };

                    $.ajax({
                        url: context_path + '/.rest/api/data/v1/updateCollocatore',
                        type:"PUT",
                        data: JSON.stringify(datalist),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                            window.location.href = paginaUtenzeCollocatori+"?success_update";
                            return false;
                        },
                        error: function(err) {
                            $('#responseUpdateUtenzaCollocatore .title-response-modal').html('Errore!');
                            $('#responseUpdateUtenzaCollocatore .text-response-modal').html(err.responseJSON.message);
                            $('#responseUpdateUtenzaCollocatore').foundation('open');
                            return false;
                        }
                    });
                    return false;
                }
                return false;
            });

        },
        utenzeClienti: function () {

            if($(".snackbar").length > 0 && $(".etica-table-clienti").length > 0) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if(urlParams.has('success_update')){
                    $(".snackbar-success-update").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-update").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-update").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-update").addClass("hidden");
                        }, 500);
                    }, 5000);
                }

                if(urlParams.has('success_delete')){
                    $(".snackbar-success-delete").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-delete").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-delete").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-delete").addClass("hidden");
                        }, 500);
                    }, 5000);
                }
            }

            $(".close-snackbar").on("click", function () {
                $(".snackbar").removeClass("active");
                setTimeout(function () {
                    $(".snackbar").addClass("hidden");
                }, 500);
            });

            // BUTTON CANCELLAZIONE UTENTE
            $("#deleteUser").on("click", function (e) {

                let paginaUtenzeClienti =  $("#form-modifica-utente input[name='paginaUtenti']").val();
                let userId= $(this).data("userid");

                $.ajax({
                    url: context_path + '/.rest/api/data/v1/deleteClient?userId='+userId,
                    type:"DELETE",
                    success: function(res){
                        window.location.href = paginaUtenzeClienti+"?success_delete";
                        return false;
                    },
                    error: function(err) {
                        $('#responseUpdateUtenzaCliente .title-response-modal').html('Errore!');
                        $('#responseUpdateUtenzaCliente .text-response-modal').html(err.responseJSON.message);
                        $('#responseUpdateUtenzaCliente').foundation('open');
                        return false;
                    }
                });
                return false;
            });

            // FORM DI UPDATE UTENZA CLIENTE
            $("#form-modifica-utente").on("submit", function (e) {
                if (!e.isDefaultPrevented()) {

                    let userId = $("#form-modifica-utente input[name='userId']").val();
                    let paginaUtenzeClienti =  $("#form-modifica-utente input[name='paginaUtenti']").val();
                    let tipologia =  $("#form-modifica-utente select[name='tipologia']").val();

                    let datalist = {
                        "userId": userId,
                        "tipologia": tipologia,
                    };

                    $.ajax({
                        url: context_path + '/.rest/api/data/v1/updateClient',
                        type:"PUT",
                        data: JSON.stringify(datalist),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                            window.location.href = paginaUtenzeClienti+"?success_update";
                            return false;
                        },
                        error: function(err) {
                            $('#responseUpdateUtenzaCliente .title-response-modal').html('Errore!');
                            $('#responseUpdateUtenzaCliente .text-response-modal').html(err.responseJSON.message);
                            $('#responseUpdateUtenzaCliente').foundation('open');
                            return false;
                        }
                    });
                    return false;
                }
                return false;
            });
        },
        profilePage: function () {
            $("#editProfile").on("submit", function (e) {
                
                // FUNZIONE JS PER L'UPDATE DELLE INFO DELLA PAGINA PROFILO 

                if (!e.isDefaultPrevented()) {

                    let datalist = {
                        "name": null,
                        "surname": null,
                        "fiscalCode": null,
                        "addressState": null,
                        "addressTown": null,
                        "address": null,
                        "cap": null,
                        "abiCode": null,
                        "cabCode": null,
                        "phone": null,
                        "privacyA": null,
                        "privacyB": null,
                        "fromUrl": null
                    };

                    let listPrivacy = {
                        pvcA: null,
                        pvcB: null,
                        fromUrl: null
                    }

                    if($("#editProfile input[name='name']").length > 0){
                        datalist.name =  $("#editProfile input[name='name']").val();
                    }

                    if($("#editProfile input[name='surname']").length > 0){
                        datalist.surname =  $("#editProfile input[name='surname']").val();
                    }

                    if($("#editProfile input[name='fiscalCode']").length > 0){
                        datalist.fiscalCode =  $("#editProfile input[name='fiscalCode']").val();
                    }

                    if($("#editProfile select[name='addressState']").length > 0){
                        datalist.addressState =  $("#editProfile select[name='addressState']").val();
                    }

                    if($("#editProfile input[name='addressTown']").length > 0){
                        datalist.addressTown =  $("#editProfile input[name='addressTown']").val();
                    }

                    if($("#editProfile input[name='address']").length > 0){
                        datalist.address =  $("#editProfile input[name='address']").val();
                    }

                    if($("#editProfile input[name='cap']").length > 0){
                        datalist.cap =  $("#editProfile input[name='cap']").val();
                    }

                    if($("#editProfile input[name='abiCode']").length > 0){
                        datalist.abiCode =  $("#editProfile input[name='abiCode']").val();
                    }
                    
                    if($("#editProfile input[name='cabCode']").length > 0){
                        datalist.cabCode =  $("#editProfile input[name='cabCode']").val();
                    }

                    if($("#editProfile input[name='phone']").length > 0){
                        datalist.phone =  $("#editProfile input[name='phone']").val();
                    }

                    if($("#editProfile input[name='privacyA']").length > 0){
                        if ($("#editProfile input[name='privacyA']").prop('checked')){
                            datalist.privacyA = true;
                            listPrivacy.pvcA = true;
                        } else {
                            datalist.privacyA = false;
                            listPrivacy.pvcA = false;
                        }
                    }
                    
                    if($("#editProfile input[name='privacyB']").length > 0){
                        if ($("#editProfile input[name='privacyB']").prop('checked')){
                            datalist.privacyB = true;
                            listPrivacy.pvcB = true;
                        } else {
                            datalist.privacyB = false;
                            listPrivacy.pvcB = false;
                        }
                    }

                    if($('.no-call-mailchimp').length === 0) {

                        datalist.fromUrl = window.location.pathname;

                        $.ajax({
                            url: context_path + '/.rest/api/mailchimp/v1/addOrUpdateMember',
                            type: "PUT",
                            data: JSON.stringify(datalist),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            success: function(response){
                                //console.log("response update", response);
                                $.ajax({
                                    url: context_path + '/.rest/api/keycloak/v1/updateUser',
                                    type:"POST",
                                    data: JSON.stringify(datalist),
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "json",
                                    success: function(res){
                                            $('#responseUpdateUser .title-response-modal').html('Dati aggiornati!');
                                            $('#responseUpdateUser .text-response-modal').html('I tuoi dati personali sono stati aggiornati con successo.');
                                            $('#responseUpdateUser').foundation('open');
                                            return false;
                                    },
                                    error: function(err) {
                                        console.log("ERROR", err);
                                        $('#responseUpdateUser .title-response-modal').html('Errore!');
                                        $('#responseUpdateUser .text-response-modal').html(err.responseText);
                                        $('#responseUpdateUser').foundation('open');
                                        return false;
                                    }
                                });
                            },
                            error: function(error) {
                                console.log("error add/update info",error);
                                $('#responseUpdateUser .title-response-modal').html('Errore');
                                $('#responseUpdateUser .text-response-modal').html('Ci sono stati dei problemi durante il salvataggio dei dati! Se il problema persiste contattare il nostro servizio clienti.');
                                $('#responseUpdateUser').foundation('open');
                                return false;
                            }
                        });
                } else {
                    $.ajax({
                        url: context_path + '/.rest/api/keycloak/v1/updateUser',
                        type:"POST",
                        data: JSON.stringify(datalist),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                                $('#responseUpdateUser .title-response-modal').html('Dati aggiornati!');
                                $('#responseUpdateUser .text-response-modal').html('I tuoi dati personali sono stati aggiornati con successo.');
                                $('#responseUpdateUser').foundation('open');
                                return false;
                        },
                        error: function(err) {
                            console.log("ERROR", err);
                            $('#responseUpdateUser .title-response-modal').html('Errore!');
                            $('#responseUpdateUser .text-response-modal').html(err.responseText);
                            $('#responseUpdateUser').foundation('open');
                            return false;
                        }
                    });
                }
                    return false;
                }
                return false;
            });

            $("#changeEmail").on("submit",function (e) {

                // FUNZIONE JS PER L'UDATE DELLA EMAIL DELLA PAGINA PROFILO  

                if (!e.isDefaultPrevented()) {
                    let email = $("#changeEmail input[name='email']").val();
                    let nuovaEmail = $("#changeEmail input[name='conferma_email']").val();

                    if(email !== "" && nuovaEmail !== "" && email === nuovaEmail){

                        let datalist = {
                            email: email,
                            fromUrl: window.location.pathname
                        };
                    
                        if($('.no-call-mailchimp').length === 0) {	
                            $.ajax({
                                url: context_path + '/.rest/api/mailchimp/v1/addOrUpdateMember',
                                type: "PUT",
                                data: JSON.stringify(datalist),
                                contentType: "application/json; charset=utf-8",
                                dataType: "json",
                                success: function(res){
                                    $.ajax({
                                        url: context_path + '/.rest/api/keycloak/v1/updateUser',
                                        type:"POST",
                                        data: JSON.stringify(datalist),
                                        contentType: "application/json; charset=utf-8",
                                        dataType: "json",
                                        success: function(res){
                                            $('#responseUpdateUser .title-response-modal').html('Indirizzo email aggiornato!');
                                            $('#responseUpdateUser .text-response-modal').html('Il tuo indirizzo email è stato aggiornato con successo.');
                                            $('#responseUpdateUser').foundation('open');
                                            return false;
                                        },
                                        error: function(err) {
                                            console.log("ERROR", err);
                                            $('#responseUpdateUser .title-response-modal').html('Errore!');
                                            $('#responseUpdateUser .text-response-modal').html(err.responseText);
                                            $('#responseUpdateUser').foundation('open');
                                            return false;
                                        }
                                    });
                                },
                                error: function(err) {
                                    console.log("ERROR", err);
                                    $('#responseUpdateUser .title-response-modal').html('Errore!');
                                    $('#responseUpdateUser .text-response-modal').html('Ci sono stati dei problemi durante il salvataggio dei dati! Se il problema persiste contattare il nostro servizio clienti.');
                                    $('#responseUpdateUser').foundation('open');
                                    return false;
                                }
                            });
                        }
                        return false;
                    }
                    return false;
                }
                return false;
            });

            $("#changePassw").on("submit", function (e) {

                // FUNZIONE JS PER L'UDATE DELLA PASSWORD DELLA PAGINA PROFILO  

                if (!e.isDefaultPrevented()) {
                    let password = $("#changePassw input[name='password']").val();
                    let conferma_psw = $("#changePassw input[name='conferma_psw']").val();

                    if(password !== "" && conferma_psw !== "" && password === conferma_psw){


                        let datalist = {
                            "password": password
                        };

                        $.ajax({
                            url: context_path + '/.rest/api/keycloak/v1/updateUser',
                            type:"POST",
                            data: JSON.stringify(datalist),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            success: function(res){
                                $('#responseUpdateUser .title-response-modal').html('Password aggiornata!');
                                $('#responseUpdateUser .text-response-modal').html('La tua nuova password è stata aggiornata con successo.');
                                $('#responseUpdateUser').foundation('open');
                                return false;
                            },
                            error: function(err) {
                                console.log("ERROR", err);
                                $('#responseUpdateUser .title-response-modal').html('Errore!');
                                $('#responseUpdateUser .text-response-modal').html(err.responseText);
                                $('#responseUpdateUser').foundation('open');
                                return false;
                            }
                        });
                        return false;
                    }
                    return false;
                }
                return false;
            });

            $("#connectUserProfile").on("submit", function (e) {

                // FUNZIONE JS PER LA MODALE DEL COLLEGAMENTRO TRA PROFILI DELLA PAGINA PROFILO  

                if (!e.isDefaultPrevented()) {
                    let accessCode = $("#connectUserProfile input[name='accessCode']").val();
                    let fiscalCode = $("#connectUserProfile input[name='fiscalCode']").val();
                    
                    //reset dei bottoni per mostrare le infromazioni
                    $('#responseConnectUser .button').addClass("is-hidden");
                    $('#responseConnectUser .close-button').removeClass("is-hidden");

                    if(accessCode !== "" && fiscalCode !== ""){

                        let datalist = {
                            "accessCode" : accessCode,
                            "fiscalCode": fiscalCode
                        };
                        
                        $.ajax({
                            // CONTROLLARE URL API SE CORRETTA
                            url: context_path + '/.rest/api/keycloak/v1/connectUser',
                            type:"POST",
                            data: JSON.stringify(datalist),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            success: function(res){
                                //console.log("res", res)
                                if(res.result === "mail"){
                                    $('#responseConnectUser .title-response-modal').html('Abbiamo inviato la richiesta all\'indirizzo mail collegato alla tua utenza cliente.');
                                    $('#responseConnectUser .text-response-modal').html('Conferma la tua richiesta cliccando sul link riportato nell\'e-mail e, dal prossimo accesso, avrai a tua disposizione tutte le informazioni personali e professionali in un unico luogo digitale.');
                                    $('#responseConnectUser .mail').removeClass("is-hidden");
                                } else if(res.result === "noMail"){
                                    $('#responseConnectUser .title-response-modal').html('Utenza cliente collegata correttamente.');
                                    $('#responseConnectUser .text-response-modal').html('Effettua nuovamente l\'accesso per poter monitorare i tuoi investimenti privati');
                                    $('#responseConnectUser .no-mail').removeClass("is-hidden");
                                    $('#responseConnectUser .close-button').addClass("is-hidden");
                                } else {
                                    $('#responseConnectUser .title-response-modal').html('Abbiamo inviato la richiesta all\'indirizzo mail collegato alla tua utenza cliente.');
                                    $('#responseConnectUser .text-response-modal').html('Conferma la tua richiesta e al prossimo accesso all\'area riservata potrai monitorare i tuoi investimenti privati');
                                    $('#responseConnectUser .mail').removeClass("is-hidden");
                                }
                                $('#responseConnectUser').foundation('open');
                            },
                            error: function(err) {
                                console.log("err", err)
                                if(err.responseText === "pending"){
                                	 $('#responseConnectUser .title-response-modal').html('Errore, la richiesta è già stata inviata!');
                                     $('#responseConnectUser .text-response-modal').html('Controlla l\'indirizzo e-mail collegato all\'utenza cliente, abbiamo inviato una mail contenente il link per confermare l\'unificazione delle utenze.');
                                     $('#responseConnectUser').foundation('open');
                                     $('#responseConnectUser .mail').removeClass("is-hidden");
                                } else {
                                	 $('#responseConnectUser .title-response-modal').html('Errore!');
                                     $('#responseConnectUser .text-response-modal').html(err.responseText);
                                     $('#responseConnectUser').foundation('open');
                                     $('#responseConnectUser .mail').removeClass("is-hidden");
                                }
                            }
                        });
                        return false;
                    }
                    return false;
                }
                return false;
            });

            $("#disconnectUserProfile").on("submit", function (e) {

                // FUNZIONE JS PER LA MODALE DELLO SCOLLEGAMENTO TRA PROFILI DELLA PAGINA PROFILO  

                if (!e.isDefaultPrevented()) {
                    let dissocia = $("#disconnectUserProfile input[name='dissocia']").val();

                    if(dissocia !== ""){

                        let datalist = {
                            "dissocia" : dissocia,
                        };

                        $.ajax({
                            // CONTROLLARE URL API SE CORRETTA
                            url: context_path + '/.rest/api/keycloak/v1/disconnectUser',
                            type:"POST",
                            data: JSON.stringify(datalist),
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            success: function(res){
                                $('#responseDisconnectUser .title-response-modal').html('L\'utenza cliente è stata scollegata con successo.');
                                $('#responseDisconnectUser .text-response-modal').html('Le modifiche saranno visibili dal prossimo accesso all\'area riservata. Nel caso volessi accedere alla tua area cliente potrai farlo loggandoti con le tue credenziali cliente.');
                                $('#responseDisconnectUser').foundation('open');
                                return false;
                            },
                            error: function(err) {
                                console.log("ERROR", err);
                                $('#responseDisconnectUser .title-response-modal').html('Errore!');
                                $('#responseDisconnectUser .text-response-modal').html(err);
                                $('#responseDisconnectUser').foundation('open');
                                return false;
                            }
                        });
                        return false;
                    }
                    return false;
                }
                return false;
            });
        },
        certifiedDomanis: function() {

            $('[name=filter_search_domains]').on('keyup paste', _.debounce(function(e){
                let iconClear = $(this).parent().find('.input-filter-clear');
                let alpha = e.type == 'keyup' && !FooTable.is.emptyString(String.fromCharCode(e.charCode)),
                    ctrl = e.type == 'keyup' && (e.which == 8 || e.which == 46), // backspace & delete
                    paste = e.type == 'paste'; 
                if(alpha || ctrl || paste) {
                    if (e.which == 13) e.preventDefault();
                    let query = e.target.value;
                    let filtering = FooTable.get('.etica-table-domanis').use(FooTable.Filtering);
                    if (query.length >= 3){
                        filtering.addFilter('search', query);
                        filtering.filter();
                        iconClear.addClass('show');

                        
                    } else {
                        filtering.removeFilter('search');
                        filtering.filter();
                        if(e.which == 8 && query.length < 3) {
                            e.target.value = '';
                        }
                        iconClear.removeClass('show');
                    }
                }
            }, 300));

            // Clear term searched
            $('[name=filter_search_domains] + .input-filter-clear').on('click', function(){
                
                let filtering = FooTable.get('.etica-table-domanis').use(FooTable.Filtering);
                filtering.removeFilter('search');
                filtering.filter();
                $('[name=filter_search_domains]').val('');
                $(this).removeClass('show');
            });


            $(".button-form-nuovo-dominio").on("click", function (e) {
                e.preventDefault();
                let paginaDomini = $("#form-nuovo-dominio #paginaDomini").val();
                let dominioBancario = $("#form-nuovo-dominio #dominio_bancario").val();
                let gruppoBancario = $("#form-nuovo-dominio #gruppo_bancario").val();
                let abi = $("#form-nuovo-dominio #abi").val();
                let richiestaStato = $("#form-nuovo-dominio #richiesta-stato option:selected").val();
                let note = $("#form-nuovo-dominio #note").val();

                if(paginaDomini !== "" && dominioBancario !== "" && gruppoBancario !== "" && abi !== "" && richiestaStato !== ""){

                    let datalist = {
                        "dominio": dominioBancario,
                        "gruppoBancario": gruppoBancario,
                        "abi": abi,
                        "stato": richiestaStato,
                        "note": note,
                    };

                    $.ajax({
                        url: context_path + '/.rest/api/data/v1/createDominioCertificato',
                        type:"POST",
                        data: JSON.stringify(datalist),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                            window.location.href= paginaDomini+"?success_create";
                        },
                        error: function(err) {
                            window.location.href= paginaDomini+"?error_create";
                        }
                    });

                }

            });

            $(".button-form-modifica-dominio").on("click", function (e) {
                e.preventDefault();
                let paginaDomini = $("#form-modifica-dominio #paginaDomini").val();
                let dominioBancario = $("#form-modifica-dominio #dominio_bancario").val();
                let gruppoBancario = $("#form-modifica-dominio #gruppo_bancario").val();
                let abi = $("#form-modifica-dominio #abi").val();
                let richiestaStato = $("#form-modifica-dominio #richiesta-stato option:selected").val();
                let note = $("#form-modifica-dominio #note").val();

                if(paginaDomini !== "" && dominioBancario !== "" && gruppoBancario !== "" && abi !== "" && richiestaStato !== ""){

                    let datalist = {
                        "dominio": dominioBancario,
                        "gruppoBancario": gruppoBancario,
                        "abi": abi,
                        "stato": richiestaStato,
                        "note": note,
                    };

                    $.ajax({
                        url: context_path + '/.rest/api/data/v1/updateDominioCertificato',
                        type:"PUT",
                        data: JSON.stringify(datalist),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function(res){
                            window.location.href= paginaDomini+"?success_edit";
                        },
                        error: function(err) {
                            window.location.href= paginaDomini+"?error_edit";
                        }
                    });

                }

            });
        },
        snackbar: function () {
            if($(".snackbar").length > 0 && $(".etica-table-domanis").length > 0) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if(urlParams.has('success_create')){
                    $(".snackbar-success-create").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-create").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-create").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-create").addClass("hidden");
                        }, 500);
                    }, 5000);
                } else if(urlParams.has('error_create')){
                    $(".snackbar-error-create").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-error-create").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-error-create").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-error-create").addClass("hidden");
                        }, 500);
                    }, 5000);
                }

                if(urlParams.has('success_edit')){
                    $(".snackbar-success-edit").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-success-edit").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-success-edit").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-success-edit").addClass("hidden");
                        }, 500);
                    }, 5000);
                } else if(urlParams.has('error_edit')){
                    $(".snackbar-error-edit").removeClass("hidden");
                    setTimeout( function () {
                        $(".snackbar-error-edit").addClass("active");
                    },300);
                    setTimeout(function () {
                        $(".snackbar-error-edit").removeClass("active");
                        setTimeout(function () {
                            $(".snackbar-error-edit").addClass("hidden");
                        }, 500);
                    }, 5000);
                }
            }

            $(".close-snackbar").on("click", function () {
                $(".snackbar").removeClass("active");
                setTimeout(function () {
                    $(".snackbar").addClass("hidden");
                }, 500);
            });
        },
        addToCalendar: function () {

            function showAddToCalendar() {

                let title = $(".info-event .title").text();
                let date_start = $(".info-event .date_start").text();
                let date_finish = $(".info-event .date_finish").text();
                let link = window.location.href;


                let myCalendar = createCalendar({
                    options: {
                        class: '',
                        id: ''
                    },
                    data: {
                        title: title,
                        start: new Date(date_start),
                        end: new Date(date_finish),     
                        address: link,
                    }
                    });
                    
                document.querySelector('.add-to-calendar-wrapper').appendChild(myCalendar);

                $(".add-to-calendar-checkbox").text("Aggiungi al calendario");
                $(".add-to-calendar-checkbox").addClass("button btn-medium");
                $(".icon-google").text("Google");
                $(".icon-yahoo").text("Yahoo");
                $(".icon-ical").text("Apple");
                $(".icon-outlook").text("Outlook");

                $(".icon-google").addClass("link_calendar");
                $(".icon-yahoo").addClass("link_calendar");
                $(".icon-ical").addClass("link_calendar");
                $(".icon-outlook").addClass("link_calendar");

                $( ".link_calendar" ).wrapAll( "<div class='wrapper_icons' />");
                
                $(".wrapper_icons").addClass("close");

                $(".add-to-calendar-checkbox").on("click", function (e) {
                    e.preventDefault();
                    $(".wrapper_icons").toggleClass("close");
                });
            }

            if($(".add-to-calendar-wrapper").length > 0) {
                showAddToCalendar();
            }

            $('.event-live-subscribe').on('click', function (e) {
                e.preventDefault();
                let idEvento = $('.info-event .event').text();
                let registrationLink = $('.info-event .registrationLink').text();
                let eventLink = window.location.href;

                let datalist = {
                    event: idEvento,
                    eventLink: eventLink
                };
                $.ajax({
                    type: "GET",
                    url: registrationLink,
                    data: datalist,
                    success: function (){
                        location.reload();
                    },
                    error: function(errore){
                        console.log('error',errore);
                    }
                });
            });

            if($(".info-event .date_start").length > 0) {

                // far girare questa funzione ogni minuto
                let date_start = $(".info-event .date_start").text();
                let date_finish = $(".info-event .date_finish").text();
                let streamingLink = $(".info-event .streamingLink").text();


                const dateStart = moment(date_start);
                const dateFinish = moment(date_finish); 
                const diffDate = dateFinish.diff(dateStart);

                let dateFormatNow = moment().format('YYYY-MM-DD HH:mm');
                let dateFormatStart = dateStart.format('YYYY-MM-DD HH:mm');
                let dateFormatFinish = dateFinish.format('YYYY-MM-DD HH:mm');

                if(moment(dateFormatNow).isSameOrAfter(dateFormatStart) && moment(dateFormatNow).isBefore(dateFormatFinish)){
                    let streamingInterval = setInterval( function () {
                        let dateStartInterval = moment(date_start);
                        let i = 1;
                        while(i <= 10) {
                            let parts = dateStartInterval.add(diffDate / 10, 'milliseconds');
                            let parsFormat = parts.format('YYYY-MM-DD HH:mm');
                            let now = moment().format('YYYY-MM-DD HH:mm');

                            //console.log("adesso",now);
                            //console.log("parsFormat",parsFormat);

                            // metto a confronto l'ora di adesso con uno dei 10 parametri frammentizzati, se è identico al minuto allora entro
                            if(moment(now).isSame(parsFormat)){

                                let idEvento = $('.info-event .event').text(); // ricavo l'id dell'evento
                                let percentualeVisualizzazione = i; // ricavo la percentuale di visualizzazione
                                $.ajax({
                                    type: 'GET',
                                    url: streamingLink,
                                    data: 'event='+idEvento+'&step='+percentualeVisualizzazione,
                                    success: function (){
                                        console.log('Dato inserito correttamente');
                                    },
                                    error: function(errore){
                                        console.log('error',errore);
                                    }
                                });
                            }
                            i++;
                        }
                        if(moment(dateFormatNow).isAfter(dateFormatFinish)) {
                            clearInterval(streamingInterval);
                        }
                    }, 60000);
                }
            }
        },
        countdown: function() {

            if($('.date_start').length > 0) {
                let countdown = document.getElementsByClassName('date_start')[0].textContent;
                let countDownDate = new Date(countdown).getTime();

                let intervalCountdown = setInterval(function() {
                    let now = new Date().getTime();
                    let distance = countDownDate - now;
                        
                    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    $('.evento-visualizza-wrapper .days').html(days < 10 ? '0' + days : days);
                    $('.evento-visualizza-wrapper .hours').html(hours < 10 ? '0' + hours : hours);
                    $('.evento-visualizza-wrapper .minutes').html(minutes < 10 ? '0' + minutes : minutes);
                    $('.evento-visualizza-wrapper .seconds').html(seconds < 10 ? '0' + seconds : seconds);
                    
                    if (distance < 0) {
                        clearInterval(intervalCountdown);
                        let giaIscritto = $(".info-event .giaIscritto").text();
                        $('.evento-visualizza-wrapper .days').html('0');
                        $('.evento-visualizza-wrapper .hours').html('0');
                        $('.evento-visualizza-wrapper .minutes').html('0');
                        $('.evento-visualizza-wrapper .seconds').html('0');
                        if($('.live-finish-event').length === 0 && giaIscritto == "true") {
                            $('.evento-visualizza-wrapper').addClass('live-finish-event');
                            location.reload();
                        }
                    }
                }, 1000);
            }
        },
        showMore: function () {
            $('.past').each(function () {
                let widthViewport = window.innerWidth;
                let rowEvents = 8;
                if (widthViewport >= 768 && widthViewport < 1024) {
                    rowEvents = 6;
                }
                let totalResults = $(this).children().children('.single-past-event').length;
                if(totalResults <= rowEvents || totalResults === undefined){
                    $('.show-more-past-events-button').hide();
                } else {
                    $(this).children().children('.single-past-event').each(function (index) {
                        if (index >= rowEvents) {
                            $(this).addClass("hidden");
                        }
                    });
                    $('.show-more-past-events-button').show();
                }
            });

            if(!this.detectIEEdge()) {
                $(".show-more-past-events-button").on("click", async function (e) {
                    e.preventDefault();
                    let widthViewport = window.innerWidth;
                    let rowEvents = 8;
                    if (widthViewport >= 768 && widthViewport < 1024) {
                        rowEvents = 6;
                    }
                    let totalResult = $(".past").children().children();
                    let result = totalResult.filter("[class~='hidden']");
                    await result.each(function (index) {
                        if (index < rowEvents) {
                            $(this).removeClass("hidden");
                        }
                    });
                    let newItemsHidden = totalResult.filter("[class~='hidden']").length;
                    if (newItemsHidden == 0) {
                        $(this).hide();
                    }
                });
            } else {
                $(".show-more-past-events-button").on("click", function (e) {
                    e.preventDefault();
                    let widthViewport = window.innerWidth;
                    let rowEvents = 8;
                    if (widthViewport >= 768 && widthViewport < 1024) {
                        rowEvents = 6;
                    }
                    let totalResult = $(".past").children().children();
                    let result = totalResult.filter("[class~='hidden']");
                    result.each(function (index) {
                        if (index < rowEvents) {
                            $(this).removeClass("hidden");
                        }
                    });
                    let newItemsHidden = totalResult.filter("[class~='hidden']").length;
                    if (newItemsHidden == 0) {
                        $(this).hide();
                    }
                });
            }

            $(window).on("resize", function () {
                $('.past').each(function () {
                    let widthViewport = window.innerWidth;
                    let rowEvents = 8;
                    if (widthViewport >= 768 && widthViewport < 1024) {
                        rowEvents = 6;
                    }
                    let totalResults = $(this).children().children('.single-past-event').length;
                    //console.log("totalResults", totalResults, rowEvents);
                    if (totalResults <= rowEvents) {
                        $('.show-more-past-events-button').hide();
                    } else {
                        $(this).children().children('.single-past-event').each(function (index) {
                            $(this).removeClass("hidden");
                            if (index >= rowEvents) {
                                $(this).addClass("hidden");
                            }
                        });
                        $('.show-more-past-events-button').show();
                    }
                });
            });
        },
        exportFunction: function () {
            //            let queryParams = new URLSearchParams(window.location.search);
            //            let body = {'codiceRapporto': queryParams.get('rapporto')};
            //        	$('#export_xlsx').on('click', function () {
            //                $.ajax({
            //              	  url: context_path + '/.rest/api/download/v1/getCaratteristiche',
            //              	  type:"POST",
            //              	  data:JSON.stringify(body),
            //              	  contentType:"application/json; charset=utf-8",
            //              	  dataType:"json"
            //                });
            //
            //        	});
        },
        footable: function () {
            if ($('.etica-table').length > 0) {
                $('.table').footable({
                    'paging': {
                        'strings': {
                            first: '<span class="fonticon icon-paginatore-fondo-sx"></span>',
                            prev: '<span class="fonticon icon-freccina-sx"></span>',
                            next: '<span class="fonticon icon-freccina-dx"></span>',
                            last: '<span class="fonticon icon-paginatore-fondo-dx"></span>'
                        },
                        'limit': 3
                    }
                });
            }

            if ($('.etica-table-ajax').length > 0) {

                let tableRapporti = $('.etica-table-ajax.rapporti'),
                    tableClienti = $('.etica-table-ajax.clienti'),
                    configTable = {};

                /*if (tableRapporti.length > 0) {
                    // console.log('ADMIN', admin);

                    // Only for Mock
                    // if (admin) {
                    // configTable.filters = './json/tabelle/filtri/getUserFiltersAdmin.json';
                    // configTable.rows = './json/tabelle/elenco_rapporti/getReportsAdmin.json';
                    // } else {
                    // configTable.filters = './json/tabelle/filtri/getUserFilters.json';
                    // configTable.rows = './json/tabelle/elenco_rapporti/getReports.json';
                    // }

                    // Only for Prod
                    configTable.filters = context_path + '/.rest/api/filters/getReportFilters';
                    configTable.rows = context_path + '/.rest/api/data/v1/getReports';

                    configTable.search = ['intestazione', 'rapporto'];
                    configTable.typeTable = 'rapporti';
                }*/
                /*if (tableClienti.length > 0) {
                	// Only for Mock
// configTable.filters = './json/tabelle/filtri/getClientFilters.json';
// configTable.rows = './json/tabelle/elenco_clienti/getClients.json';
                	
                	// Only for Prod
                    configTable.filters = context_path + '/.rest/api/filters/getReportFilters';
                    configTable.rows = context_path + '/.rest/api/data/v1/getClients';
//                    configTable.search = ['codiceAccesso', 'nomeCognomeSocieta', 'cfPiva', 'email'];
                    configTable.search = ['codiceAccesso', 'nomeCognomeSocieta', 'cfPiva'];
                    configTable.typeTable = 'clienti';
                }*/

                if (!_.isEmpty(configTable)) {
                    etica.footable.init(configTable);
                }
            }
        },
        foundation: function () {

            $(document).foundation();

            $('.return-top').on('click touchstart', function (e) {
                e.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, 'slow');
                return false;
            });
        },
        header: function () {

            $('.burger').on('click touchstart', function (e) {
                e.preventDefault();
                $('.main-menu > ul > li a').removeClass('active');
                if ($('body').hasClass('opened')) {
                    $('body').removeClass('opened');
                } else {
                    $('body').addClass('opened');
                }
            });

            $('.js-open-menu').on('click', function () {
                // $('.area-riservata-sidebar').slideToggle('left');
                if ($('.area-riservata-sidebar').hasClass('open')) {
                    $('.area-riservata-sidebar').removeClass('open');
                    $(this).removeClass('is-active');
                } else {
                    $('.area-riservata-sidebar').addClass('open');
                    $(this).addClass('is-active');
                }
            });
            $('.user-wrapper').on('show.zf.dropdownmenu', function (ev, $el) {
                if ($('.area-riservata-sidebar').hasClass('open')) {
                    $('.area-riservata-sidebar').removeClass('open');
                    $('.js-open-menu').removeClass('is-active');
                }
            });

            $('.sidebar-menu').each(function () {
                let _sidebarMenu = $(this);
                $(this).find('.with-menu > a span').on('click', function (e) {
                    e.preventDefault();
                    let _linkA = $(this).parent('a');
                    if (!_linkA.parent('li').hasClass('open')) {
                        _sidebarMenu.find('li ul').slideUp();
                        _sidebarMenu.find('li').removeClass('open');
                        _linkA.parent('li').addClass('open');
                        _linkA.next('ul').slideDown();
                    } else {
                        _linkA.parent('li').removeClass('open');
                        _linkA.next('ul').slideUp();
                    }
                });

                if (_sidebarMenu.find('.active')) {
                    let _linkActive = _sidebarMenu.find('.active');
                    if (!_linkActive.parent('li').hasClass('with-menu')) {
                        _linkActive.parents('li').addClass('open');
                        _linkActive.parents('ul').show();
                    }
                }
            });
        },
        login: function () {

            if ($('.login-wrapper').length > 0) {
                etica.toggleLogin.initToggleLogin();
                etica.toggleLogin.setToggleLogin();
            }

            $('.showing').on('click', function () {
                let groupContainer = $(this).parent('.mc-field-group');
                groupContainer.find('input').attr('type', 'text');
                $(this).hide();
                groupContainer.addClass('visible');
                groupContainer.find('.hiding').show();
            });

            $('.hiding').on('click', function () {
                let groupContainer = $(this).parent('.mc-field-group');
                groupContainer.find('input').attr('type', 'password');
                groupContainer.removeClass('visible');
                $(this).hide();
                groupContainer.find('.showing').show();
            });

            if ($('.tipologia_utente').length > 0) {
            	if(window.location.hash) {
            		if(window.location.hash == '#cliente'){
	            		$('.tipologia_utente input').prop("checked", false);
	            		$("#cliente_privato").prop("checked", true);
	            		$('#form_cliente_privato').show();
	            		$('#form_collocatore').hide();
            		} else if(window.location.hash == '#collocatore'){
	            		$('.tipologia_utente input').prop("checked", false);
	            		$("#collocatore").prop("checked", true);
	            		$('#form_cliente_privato').hide();
	            		$('#form_collocatore').show();
	            	}
        		} else {
            		$('.tipologia_utente input').prop("checked", false);
            		$("#cliente_privato").prop("checked", true);
            		$('#form_cliente_privato').show();
            		$('#form_collocatore').hide();
        		}
            }
            
            $('.tipologia_utente input').change(function () {
                if ($('#cliente_privato').prop('checked')) {
                    $('#form_cliente_privato').show();
                    $('#form_collocatore').hide();
                } else {
                    $('#form_cliente_privato').hide();
                    $('#form_collocatore').show();
                }
            });
        },
        floatLabels: function () {
            let fieldFloatLabel = $('.field-float-label');
            fieldFloatLabel.each(function () {
                let field = $(this);
                let input = field.find('input');
                let label = field.find('label');
                let textarea = field.find('textarea');
                let select = field.find('select');

                function checkInput() {
                    let valueLength = input.val().length;

                    if (valueLength > 0) {
                        label.addClass('has-value');
                    } else {
                        label.removeClass('has-value');
                    }
                }
                function checkTextarea() {
                    let valueLength = textarea.val().length;

                    if (valueLength > 0) {
                        label.addClass('has-value');
                    } else {
                        label.removeClass('has-value');
                    }
                }
                function checkSelect() {
                    let valueLength = select.val().length;

                    if (valueLength > 0) {
                        label.addClass('has-value');
                    } else {
                        label.removeClass('has-value');
                    }
                }
                if (input.length > 0) {
                    input.change(function () {
                        checkInput();
                    });
                }
                if (textarea.length > 0) {
                    textarea.change(function () {
                        checkTextarea();
                    });
                }
                if (select.length > 0) {
                    select.change(function () {
                        checkSelect();
                    });
                }
            });
        },
        form: function () {
            $('.js-btn-edit-form').on('click', function () {
                let form = $(this).closest('form');
                let formName = form.data('formName');
                let store = {};

                if (form && form.length > 0) {
                    form.find('.editable').attr('disabled', false);
                    if (form.find('.editable').is('select')) form.find('.editable').parent().removeClass('select-disabled');
                    form.find('.editable').each(function (index) {
                        store[$(this).attr('id')] = $(this).val();
                        if ($(this).is(':checkbox')) {
                            store[$(this).attr('id')] = $(this).is(':checked') ? 'true' : 'false';
                        }
                        if ($(this).is('select')) {
                            store[$(this).attr('id')] = $(this).children('option:selected').val();
                        }
                    });
                    if (typeof Storage !== 'undefined') {
                        localStorage.setItem(formName, JSON.stringify(store));
                    } else {
                        // Sorry! No Web Storage support..
                    }
                    form.find('.edit-wrapper').addClass('hide');
                    form.find('.cancel-wrapper').removeClass('hide');
                    form.find('.submit-wrapper').removeClass('hide');
                }
            });
            $('.js-btn-cancel-form').on('click', function () {
                let form = $(this).closest('form');
                let formName = form.data('formName');

                if (form && form.length > 0) {
                    if (localStorage.getItem(formName)) {
                        let store = JSON.parse(localStorage.getItem(formName));
                        form.find('.editable').each(function (index) {
                            if ($(this).is('select')) $(this).parent().addClass('select-disabled');
                            if ($(this).is(':checkbox')) {
                                if (store[$(this).attr('id')] === 'true') {
                                    $('#' + $(this).attr('id')).prop('checked', true);
                                } else {
                                    $('#' + $(this).attr('id')).prop('checked', false);
                                }
                            }
                            $('#' + $(this).attr('id')).val(store[$(this).attr('id')]);
                        });
                    }
                    form.find('.editable').attr('disabled', true);
                    form.find('.edit-wrapper').removeClass('hide');
                    form.find('.cancel-wrapper').addClass('hide');
                    form.find('.submit-wrapper').addClass('hide');
                }
            });

            $('.js-upload-file').on('change', function () {
                if ($(this).val()) {
                    $(this).parent().find('div').text($(this)[0].files[0].name);
                }
            });

            // Password Strength
            i18next.init({
                lng: 'it',
                resources: {
                    it: {
                        translation: {
                            'veryWeak': 'Molto debole',
                            'weak': 'Debole',
                            'normal': 'Normale',
                            'medium': 'Media',
                            'strong': 'Forte',
                            'veryStrong': 'Molto forte'
                        }
                    }
                }
            }, function () {
                let options = {};
                options.ui = {
                    container: '#pwd-container',
                    viewports: {
                        progress: '.pwstrength_viewport_progress',
                        verdict: '.pwstrength_viewport_verdict'
                    }
                };
                options.common = {
                    onLoad: function () {
                        $('#messages').text('Start typing password');
                    },
                    zxcvbn: true,
                    zxcvbnTerms: ['samurai', 'shogun', 'bushido', 'daisho', 'seppuku'],
                    userInputs: ['#year', '#familyname']
                };
                $('.pwd-field').pwstrength(options);
                $('.pwd-field').on('keyup', function (event) {
                    $('.pwstrength_viewport-container').addClass('show');
                });
                $('.pwd-field').on('focusout', function () {
                    $('.pwstrength_viewport-container').removeClass('show');
                });
            });
        },
        graph: function () {
            let numberFormatComma = function (num, decimalComma) {
                if (!decimalComma) {
                    return num;
                } else {
                    return num.toString()

                    // .toFixed(2) // always two decimal digits
                    .replace('.', ',') // replace decimal point character with
                    // ,
                    // .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
                    ; // use . as a separator
                }
            };
            let decimalCommaLanugages = ['it', 'es'];
            let decimalComma = true;
            let graficoAssetsAlloc = function () {
                let assetsAllocArray = [];
                let queryParams = new URLSearchParams(window.location.search);

                if($('#chartAllocation').length && queryParams.get('rapporto').length){
                    $.getJSON(context_path + '/.rest/api/data/v1/getAssets?rapporto=' + queryParams.get('rapporto'), function (data) {
                        let colors = {
                            'AZ': '#E07000',
                            'OB': '#FED018',
                            'LIQ': '#1B336F',
                            'OTH': '#03C03C'
                        };
                        $.each(data.series, function (key, value) {
                            let valore = value.valore * 100;
                            assetsAllocArray.push({
                                y: +valore.toFixed(2),
                                name: value.descrizione,
                                color: colors[value.codice],
                                fondo: +valore.toFixed(2)
                            });
                        });

                        // Create the chart
                        $('#chartAllocation').highcharts({
                            chart: {
                                type: 'pie'
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: 'Asset Allocation'
                            },
                            yAxis: {
                                title: {
                                    text: 'Total percent market share'
                                }
                            },
                            plotOptions: {
                                pie: {
                                    shadow: false,
                                    center: ['50%', '50%'],
                                    dataLabels: {
                                        distance: 10
                                    }
                                }
                            },
                            tooltip: {
                                valueSuffix: '%'
                            },
                            series: [{
                                name: 'Valore',
                                data: assetsAllocArray,
                                size: '80%',
                                innerSize: '60%',
                                dataLabels: {
                                    formatter: function () {
                                        return '<b>' + this.point.name + '</b><br /><b>Fondo:</b> ' + numberFormatComma(this.point.fondo, decimalComma) + '%';
                                    }
                                }
                            }]
                        });
                    });
                }
            };
            graficoAssetsAlloc();
        },
        slider: function () {
            // Teaser production Service Slider
            etica.swiper.cardInfo();
            $('body').on('resizeme.zf.trigger', function () {
                etica.swiper.cardInfo();
            });
        },
        homepageModal: function () {
            const element = $('#homepage_modal');
            let isModalToBeShown = false;
            if (element) { isModalToBeShown = element.attr('data-modal') == 'true'; }
            if (isModalToBeShown) {
                console.log({ a: $('#homepageModale') });
                $('#homepageModale').foundation('open');
            };
            const button = $('#homepageModaleButton');
            button.on('click', () => {
                $('#homepageModale').foundation('close');
            });
        }
    },
    swiper: {
        cardInfo: function () {
            if ($('.card-info-wrapper .swiper-container').length > 0) {
                if (Foundation.MediaQuery.atLeast('large')) {
                    if (etica.slider.card_info !== undefined) {
                        etica.slider.card_info.destroy(true, false);
                        etica.slider.card_info = undefined;
                        $('.card-info-wrapper .swiper-wrapper').removeAttr('style');
                        $('.card-info-wrapper .swiper-slide').removeAttr('style');
                    }
                    return;
                } else {
                    if (etica.slider.card_info == undefined) {
                        etica.slider.card_info = new Swiper('.card-info-wrapper .swiper-container', {
                            a11y: { enabled: false },
                            observer: true,
                            pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
                            slidesPerView: 'auto',
                            spaceBetween: 15
                        });
                    }
                }
            }
        }
    },
    toggleLogin: {
        checkToggle: function (toggleChecked) {
            let input = $('.toggle-input input');
            let placheolder = input.parent().find('label');
            let placeholderCliente = input.data('placeholderCliente');
            let placeholderCollocatore = input.data('placeholderCollocatore');
            let form = input.closest('form');
            let password = form.find('input:password');
            let colDx = $('.login-secondCol');

            if (!toggleChecked) {
                Cookies.set('typeLogger', 'cliente', { expires: 7 });

                input.removeClass('email').addClass('email-codice');
                input.val('');
                password.val('');
                placheolder.text(placeholderCliente);
                let validator = form.validate();
                validator.resetForm();
                
                if($(".register ").length > 0){
                    $(".registrati-collocatore").css("display", "none");
                    $(".registrati-cliente").css("display", "inline-block");
                }

                colDx.removeClass('collocatore').addClass('cliente');
                colDx.find('.login-text.login-text-collocatore').hide();
                colDx.find('.login-text.login-text-cliente').show();
            } else {
                Cookies.set('typeLogger', 'collocatore', { expires: 7 });

                input.removeClass('email-codice').addClass('email');
                input.val('');
                password.val('');
                placheolder.text(placeholderCollocatore);
                let validator = form.validate();
                validator.resetForm();

                if($(".register ").length > 0){
                    $(".registrati-cliente").css("display", "none");
                    $(".registrati-collocatore").css("display", "inline-block");
                }

                colDx.removeClass('cliente').addClass('collocatore');
                colDx.find('.login-text.login-text-cliente').hide();
                colDx.find('.login-text.login-text-collocatore').show();
            }
        },
        initToggleLogin: function () {
            if (window.location.hash) {
                // Fragment exists
                if (window.location.hash == '#cliente') {
                    $('.toggleLogin').prop('checked', false);
                } else if (window.location.hash == '#collocatore') {
                    $('.toggleLogin').prop('checked', true);
                }
            } else {
                // Fragment doesn't exist
                if (Cookies.get('typeLogger')) {
                    if (Cookies.get('typeLogger') === 'cliente') {
                        $('.toggleLogin').prop('checked', false);
                    } else {
                        $('.toggleLogin').prop('checked', true);
                    }
                }
            }
            let toggleChecked = $('.toggleLogin').is(':checked');
            etica.toggleLogin.checkToggle(toggleChecked);
        },
        setToggleLogin: function () {
            $('.toggleLogin').on('change', function () {
                let toggleChecked = this.checked;
                etica.toggleLogin.checkToggle(toggleChecked);
            });
        }
    },
    
    footable: {
        init: function (config) {

            let myTable = '';

            /*

            function setQueryParams(param) {
                let queryParams = new URLSearchParams(window.location.search);
                queryParams.set(param.name, param.value);
                history.replaceState(null, null, '?' + queryParams.toString());
            }
            function deleteQyeryParams(param) {
                let queryParams = new URLSearchParams(window.location.search);
                if (queryParams.get(param.name)) {
                    queryParams.delete(param.name);
                    history.replaceState(null, null, '?' + queryParams.toString());
                }
            }
            function resetFilters() {
            	let ft = FooTable.get('.etica-table-ajax');
                let filterAbi = $('.section-filter-abi'),
                    filterCab = $('.section-filter-cab'),
                    filterSearch = $('.section-filter-search'),
                    queryParams = new URLSearchParams(window.location.search),
                    iconClear = $('.input-filter-clear'),
                    filtering = FooTable.get('.etica-table-ajax').use(FooTable.Filtering);

                if (filterAbi.find('[name=filter_abi]').length > 0) {
                    let valAbi = $('[name=filter_abi]').is('span') ? $('[name=filter_abi]').text() : $('[name=filter_abi] option:first-child').val();
                    filterAbi.find('[name=filter_abi]').val(valAbi);
                    // filtering.addFilter('abi', valAbi, ['abi']);
                    if (queryParams.get('abi')) queryParams.set('abi', valAbi);
                }
                if (filterCab.find('[name=filter_cab]').length > 0) {
                    filterCab.find('[name=filter_cab]').val('all');
                    // filtering.removeFilter('cab');
                    if (queryParams.get('cab')) queryParams.set('cab', 'all');
                }
                if (filterSearch.find('[name=filter_search]').length > 0) {
                    filterSearch.find('[name=filter_search]').val('');
                    filtering.removeFilter('search');
                    if (queryParams.get('search')) queryParams.delete('search');
                    if (iconClear.length > 0) iconClear.removeClass('show');
                }

//                filtering.filter();
                history.replaceState(null, null, '?' + queryParams.toString());


                // reset dei filtri e ricompilazione di tutti i campi

                let myAbi = $('[name=filter_abi]').is('span') ? $('[name=filter_abi]').text() : $('[name=filter_abi] option:first-child').val();
                let myCab = $('[name=filter_cab] option:first-child').val();


                let body = {
                    "abis": myAbi === 'all' ? abis : [myAbi],
                    "cabs": myCab === 'all' ? cabs : [myCab]
                };

                $.ajax({
                    url: config.rows,
                    type: "POST",
                    data: JSON.stringify(body),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: async function (data, status) {
                        let copyResult = data;
                        let cabList = copyResult.map(item => item.cab); // * recupero tutti i cab presenti nella risposta
                        cabList = [...new Set(cabList)];
                        
                        let abiList = copyResult.map(item => item.abi); // * recupero tutti i cab presenti nella risposta
                        abiList = [...new Set(abiList)];

                        let filterCab = $('.section-filter-cab');
                        let filterAbi = $('.section-filter-abi');

                        $('.section-filter-cab .wrap-filter').html("");
                        $('.section-filter-cab .wrap-filter').append("<label >CAB</label>");
                        $('.section-filter-abi .wrap-filter').html("");
                        $('.section-filter-abi .wrap-filter').append("<label >ABI</label>");


                        let filterCabContent = '';
                        if (!_.isNull(cabList) && _.isArray(cabList) && cabList.length > 0) {
                        	filterCabContent = '<span class="wrap-filter-select">';
                            filterCabContent += '<select id="filter_cab" name="filter_cab">';
                            filterCabContent += '<option value="all" selected>Tutti</option>';
                            _.each(cabList, function (cab) {
                                filterCabContent += '<option value="' + cab + '">' + cab + '</option>';
                            });
                            filterCabContent += '</select>';
                            filterCabContent += '</span>';
                            
                            filterCab.find('.wrap-filter').append(filterCabContent);
                        }

                        let filterAbiContent = '';
                        if(!_.isNull(abiList) && _.isArray(abiList) && abiList.length === 1){
                            filterAbiContent = '<span name="filter_abi" class="label-text">'+abiList[0]+'</span>';
                            filterAbi.find('.wrap-filter').append(filterAbiContent);
                        } else {
                            if (!_.isNull(abiList) && _.isArray(abiList) && abiList.length > 0) {
                                filterAbiContent = '<span class="wrap-filter-select">';
                                filterAbiContent += '<select id="filter_abi" name="filter_abi">';
                                filterAbiContent += '<option value="all" selected>Tutti</option>';
                                _.each(abiList, function (abi) {
                                    filterAbiContent += '<option value="' + abi + '">' + abi + '</option>';
                                });
                                filterAbiContent += '</select>';
                                filterAbiContent += '</span>';
                                
                                filterAbi.find('.wrap-filter').append(filterAbiContent);
                            }
                        }

                        let rows = '';
                        rows =  await data.map(item => {
                            let obj = {};
                            obj.rapporto = {
                                options: { classes: 'border-right' },
                                value: item.codiceRapporto
                            };
                            if (item.abi) {
                                obj.abi = {
                                    options: { classes: 'border-right' },
                                    value: item.abi
                                };
                            }
                            obj.cab = {
                                options: { classes: 'border-right' },
                                value: item.cab
                            };
                            obj.intestazione = {
                                options: { classes: 'border-right' },
                                value: item.intestazione
                            };
                            obj.collocatore = {
                                options: { classes: 'border-right' },
                                value: item.collocatore
                            };
                            obj.valoreAttuale = {
                                options: { classes: 'border-right td-with-number' },
                                value: typeof item.valoreAttuale === 'number' ? item.valoreAttuale.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €' : item.valoreAttuale.replace('.', ',') + ' €'
                            };
                            let linkDettaglio = !_.isNull($('#link-dettaglio')) && $('#link-dettaglio').length ? $('#link-dettaglio').val() + '?rapporto=' + item.codiceRapporto : '';
                            obj.dettaglio = '<a class=\'anchor-link\' href=\'' + linkDettaglio + '\'>Visualizza</a>';
                            return {
                                options: {},
                                value: obj
                            };
                        });
                        
                        ft.rows.load(rows);
                    }
                });
            }
            */

            let filtri = {};
            let abis = [];
            let cabs = [];

            // Init Table
            $.get(config.filters, function (data, status) {
                $('.overlay-container').removeClass('hide-overlay-container');
                /*let filterAbi = $('.section-filter-abi'),
                    filterCab = $('.section-filter-cab'),
                    filterSearch = $('.section-filter-search');
                let admin = data.admin !== null && data.admin;
                if (!_.isNull(data.abi)) {
                    filtri.abi = data.abi.map(val => {
                        return { label: val, value: val };
                    });
                }
                if (!_.isNull(data.cab)) {
                    filtri.cab = data.cab.map(val => {
                        return { label: val, value: val };
                    });
                }*/

                if (status === 'success') {
                    let filters = filtri;
                    let filterAbiContent = '';
                    let filterCabContent = '';
                    let queryParams = new URLSearchParams(window.location.search);
                    let iconClear = $('.input-filter-clear');

                    /*
                    if (!_.isNull(filters.abi) && _.isArray(filters.abi) && filters.abi.length > 0) {
                        if (filters.abi.length > 1) {
                            filterAbi.removeClass('medium-2 xlarge-1').addClass('medium-10 xlarge-2');
                            filterCab.removeClass('xlarge-3').addClass('xlarge-2');
                            filterAbiContent = '<span class="wrap-filter-select">';
                            filterAbiContent += '<select name="filter_abi">';
                            filterAbiContent += '<option value="all" selected>Tutti</option>';
                            _.each(filters.abi, function (abi, i) {
                                let selected = '';
                                if (!_.isNull(queryParams.get('abi'))) {
                                    selected = queryParams.get('abi') === abi.value ? 'selected' : '';
                                }
                                filterAbiContent += '<option value="' + abi.value + '" ' + selected + '>' + abi.label + '</option>';
                            });
                            filterAbiContent += '</select>';
                            filterAbiContent += '</span>';
                            filterAbi.find('.wrap-filter').append(filterAbiContent);
                        } else {
                            // Utente
                            filterAbi.addClass('small-6 medium-2 xlarge-1');
                            filterAbiContent = '<span name="filter_abi" class="label-text">' + filters.abi[0].value + '</span>';
                            filterAbi.find('.wrap-filter').append(filterAbiContent);
                        }
                    }
                    if (!_.isNull(filters.cab) && _.isArray(filters.cab) && filters.cab.length > 0) {
                        filterCabContent = '<span class="wrap-filter-select">';
                        filterCabContent += '<select id="filter_cab" name="filter_cab">';
                        filterCabContent += '<option value="all">Tutti</option>';
                        _.each(filters.cab, function (cab) {
                            let selected = '';
                            if (!_.isNull(queryParams.get('cab'))) {
                                selected = queryParams.get('cab') === cab.value ? 'selected' : '';
                            }
                            filterCabContent += '<option value="' + cab.value + '" ' + selected + '>' + cab.label + '</option>';
                        });
                        filterCabContent += '</select>';
                        filterCabContent += '</span>';
                        filterCab.find('.wrap-filter').append(filterCabContent);
                    }
                    // if(!_.isNull(filters.search)) {
                    // if(filters.search != '') {
                    // filterSearch.find('input').val(filters.search);
                    // if(iconClear.length > 0) iconClear.addClass('show');
                    // } else {
                    // if( !_.isNull(queryParams.get('search')) ) {
                    // filterSearch.find('input').val(queryParams.get('search'));
                    // if(iconClear.length > 0) iconClear.addClass('show');
                    // }
                    // }
                    // }

                    */
                   /*
                    abis = !_.isNull(filtri.abi) && _.isArray(filtri.abi) && filtri.abi.length > 0 ? filtri.abi.map(val => val.value) : [];
                    cabs = !_.isNull(filtri.cab) && _.isArray(filtri.cab) && filtri.cab.length > 0 ? filtri.cab.map(val => val.value) : [];

                    // setting the first value after "all" to make calls faster than calls "all" value
                    let initAbi = 'all';
                    let initCab = 'all';
*/
                    /*
                    if(config.typeTable == 'rapporti') {
                        if(!$('[name=filter_abi]').is('span')){
                            $('select[name=filter_abi] option:eq(1)').attr('selected', 'selected');
                        }
                        $('select[name=filter_cab] option:eq(1)').attr('selected', 'selected');
    
                        initAbi = $('[name=filter_abi]').is('span') ? $('[name=filter_abi]').text() : $('[name=filter_abi]').val();
                        initCab = $('[name=filter_cab]').val();
                    }
                    */
                    
                    let body = {
                        "abis": initAbi === 'all' ? abis : [initAbi],
                        "cabs": initCab === 'all' ? cabs : [initCab]
                    };
                    $.ajax({
                        url: config.rows,
                        type: "POST",
                        data: JSON.stringify(body),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function (data, status) {
                            let rows = '';
                            let columns = [];
                            /*
                            if (config.typeTable == 'rapporti') {
                                columns.push({ name: 'rapporto', title: 'Rapporto', classes: 'border-right th-mobile-1_3' });
                                if (abis.length > 0) {
                                    columns.push({ name: 'abi', title: 'ABI', breakpoints: 'xs sm', classes: 'border-right' });
                                }
                                columns.push({ name: 'cab', title: 'CAB', breakpoints: 'xs sm', classes: 'border-right' });
                                columns.push({ name: 'intestazione', title: 'Intestazione', classes: 'border-right th-mobile-1_3' });
                                columns.push({ name: 'collocatore', title: 'Collocatore', breakpoints: 'xs sm', filterable: false, classes: 'border-right' });
                                columns.push({ name: 'valoreAttuale', title: 'Valore attuale *', breakpoints: 'xs sm', filterable: false, classes: 'border-right' });
                                columns.push({ name: 'dettaglio', title: 'Rapporto', classes: 'border-right th-mobile-1_3' });

                                rows = data.map(item => {
                                    let obj = {};
                                    obj.rapporto = {
                                        options: { classes: 'border-right' },
                                        value: item.codiceRapporto
                                    };
                                    if (item.abi) {
                                        obj.abi = {
                                            options: { classes: 'border-right' },
                                            value: item.abi
                                        };
                                    }
                                    if (item.cab) {
                                        obj.cab = {
                                            options: { classes: 'border-right' },
                                            value: item.cab
                                        };
                                    }
                                    obj.intestazione = {
                                        options: { classes: 'border-right' },
                                        value: item.intestazione
                                    };
                                    obj.collocatore = {
                                        options: { classes: 'border-right' },
                                        value: item.collocatore
                                    };
                                    obj.valoreAttuale = {
                                        options: { classes: 'border-right td-with-number' },
                                        value: typeof item.valoreAttuale === 'number' ? item.valoreAttuale.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €' : item.valoreAttuale.replace('.', ',') + ' €'
                                    };
                                    let linkDettaglio = !_.isNull($('#link-dettaglio')) && $('#link-dettaglio').length ? $('#link-dettaglio').val() + '?rapporto=' + item.codiceRapporto : '';
                                    obj.dettaglio = '<a class=\'anchor-link\' href=\'' + linkDettaglio + '\'>Visualizza</a>';
                                    return {
                                        options: {},
                                        value: obj
                                    };
                                });
                            }

                            if (config.typeTable == 'clienti') {
                                columns.push({ name: 'codiceAccesso', title: 'Codice di accesso', classes: 'border-right th-mobile-1_3' });
                                columns.push({ name: 'nomeCognomeSocieta', title: 'Nome e Cognome / Società', breakpoints: 'xs sm', classes: 'border-right' });
                                columns.push({ name: 'cfPiva', title: 'Codice fiscale / Partita IVA', breakpoints: 'sm md', classes: 'border-right' });
//                                columns.push({ name: 'email', title: 'E-mail', classes: 'border-right th-mobile-1_3' });
//                                columns.push({ name: 'dataAttivazioneCliente', title: 'Data di attivazione cliente', breakpoints: 'xs sm', 'filterable': false, classes: 'border-right' });
                                columns.push({ name: 'dettaglio', title: 'Dettaglio', 'filterable': false, classes: 'th-mobile-1_3' });

                                rows = data.map(item => {
                                    let obj = {};
                                    obj.codiceAccesso = {
                                        options: { classes: 'border-right' },
                                        value: item.codiceAccesso
                                    };
                                    obj.nomeCognomeSocieta = {
                                        options: { classes: 'border-right' },
                                        value: item.nomeCognomeSocieta
                                    };
                                    obj.cfPiva = {
                                        options: { classes: 'border-right' },
                                        value: item.cfPiva
                                    };
//                                    obj.email = {
//                                        options: { classes: 'border-right' },
//                                        value: item.email
//                                    };
//                                    obj.dataAttivazioneCliente = {
//                                        options: { classes: 'border-right' },
//                                        value: item.dataAttivazioneCliente
//                                    };
                                    
                                    let linkDettaglio = !_.isNull($('#link-dettaglio')) && $('#link-dettaglio').length ? $('#link-dettaglio').val() + '?cliente=' + item.codiceAccesso : '';
                                    obj.dettaglio = '<a class=\'anchor-link\' href=\'' + linkDettaglio + '\'>Visualizza</a>';
                                    return {
                                        options: {},
                                        value: obj
                                    };
                                });
                            }*/

                            $('.table').on({
                                'ready.ft.table': function (e, ft) {
                                    let filtering = FooTable.get('.etica-table-ajax').use(FooTable.Filtering);
                                    // if(!_.isNull(filters.abi)) {
                                    // if(_.isArray(filters.abi)) {
                                    // if( !_.isNull(queryParams.get("abi")) ) {
                                    // filtering.addFilter('abi',
                                    // queryParams.get("abi"), ['abi']);
                                    // } else {
                                    // filtering.addFilter('abi',
                                    // filters.abi[0].value, ['abi']);
                                    // }
                                    // }
                                    // }
                                    // if( !_.isNull(queryParams.get("cab")) ) {
                                    // if (queryParams.get("cab") === 'all'){
                                    // filtering.removeFilter('cab');
                                    // } else {
                                    // filtering.addFilter('cab',
                                    // queryParams.get("cab"), ['cab']);
                                    // }
                                    // }
                                    if (!_.isNull(queryParams.get('search')) && queryParams.get('search') != '') {
                                        filtering.addFilter('search', queryParams.get('search'), config.search);
                                        filterSearch.find('input').val(queryParams.get('search'));
                                        if (iconClear.length > 0) iconClear.addClass('show');
                                    }
                                    filtering.filter();
                                },
                                'after.ft.filtering': function (e, ft) {
                                    if (ft.rows.array.length == 0) {
                                        $(e.currentTarget).find('thead').hide();
                                    } else {
                                        $(e.currentTarget).find('thead').show();
                                    }
                                },
                                'draw.ft.table': function(e, ft) {
                                    $('.footable-loader').remove();
                                    $(e.currentTarget).show();
                                },
                                'predraw.ft.table': function(e, ft) {
                                    let $loader = $('<div/>', { 'class': 'footable-loader' }).append($('<span/>', {'class': 'fooicon fooicon-loader'}));
                                    $(e.currentTarget).hide();
                                    $(e.currentTarget).after($loader);
                                },
                            }).footable({
                                'columns': columns,
                                'rows': rows,
                                'paging': {
                                    'strings': {
                                        first: '<span class="fonticon icon-paginatore-fondo-sx"></span>',
                                        prev: '<span class="fonticon icon-freccina-sx"></span>',
                                        next: '<span class="fonticon icon-freccina-dx"></span>',
                                        last: '<span class="fonticon icon-paginatore-fondo-dx"></span>'
                                    },
                                    'limit': 3
                                },
                                'empty': 'La ricerca non ha prodotto risultati'
                            });
                            $('.overlay-container').addClass('hide-overlay-container');
                        }
                    });
                }
            });

            /*
            // Manage Filter ABI
            $('body').on('change', '[name=filter_abi]', function () {
                $('.overlay-container').removeClass('hide-overlay-container');
            	let queryParams = new URLSearchParams(window.location.search);
                let ft = FooTable.get('.etica-table-ajax');
                let _this = $(this);
                let myAbi = _this.val();
                $('[name=filter_cab]').val('all');
                let urlApi = context_path + '/.rest/api/data/v1/getReports';
                let downloadUrl = context_path + '/.rest/api/download/v1/getRapporti';

                // ! Settare la select con i nuovi cab
                let myCab = "all";  // * Setto il valore del cab come ALL in modo da resettare sempre i valori selezionati
                let myParam = {};
                myParam.name = 'cab';
                myParam.value = 'all';
                setQueryParams(myParam);
                

                $('.btn-reset-filters').prop('disabled', false);
                let body = {
                    "abis": myAbi === 'all' ? abis : [myAbi],
                    "cabs": myCab === 'all' ? cabs : [myCab]
                };
                if ($("#export_rapporti_xlsx").length) {
                    $("#export_rapporti_xlsx").attr('href', downloadUrl + '?search=' + encodeURI(JSON.stringify(body)));
                }

                $.ajax({
                    url: config.rows,
                    type: "POST",
                    data: JSON.stringify(body),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data, status) {
                        let copyResult = data;
                        let cabList = copyResult.map(item => item.cab); // * recupero tutti i cab presenti nella risposta
                        cabList = [...new Set(cabList)];
                        cabList.sort(); // * ordino tutti in A-Z tutti i cab ottenuti
                        let filterCab = $('.section-filter-cab');

                        $('.section-filter-cab .wrap-filter').html("");
                        $('.section-filter-cab .wrap-filter').append("<label >CAB</label>");

                        let filterCabContent = '';
                        if (!_.isNull(cabList) && _.isArray(cabList) && cabList.length > 0) {
                        	filterCabContent = '<span class="wrap-filter-select">';
                            filterCabContent += '<select id="filter_cab" name="filter_cab">';
                            filterCabContent += '<option value="all" selected>Tutti</option>';
                            _.each(cabList, function (cab) {
                                filterCabContent += '<option value="' + cab + '" >' + cab + '</option>';
                            });
                            filterCabContent += '</select>';
                            filterCabContent += '</span>';
                            
                            filterCab.find('.wrap-filter').append(filterCabContent);
                        }

                        //cabs = !_.isNull(cabList) && _.isArray(cabList) && cabList.length > 0 ? cabList.map(val => val.value) : [];

                        let rows = '';
                        rows = data.map(item => {
                            let obj = {};
                            obj.rapporto = {
                                options: { classes: 'border-right' },
                                value: item.codiceRapporto
                            };
                            if (item.abi) {
                                obj.abi = {
                                    options: { classes: 'border-right' },
                                    value: item.abi
                                };
                            }
                            obj.cab = {
                                options: { classes: 'border-right' },
                                value: item.cab
                            };
                            obj.intestazione = {
                                options: { classes: 'border-right' },
                                value: item.intestazione
                            };
                            obj.collocatore = {
                                options: { classes: 'border-right' },
                                value: item.collocatore
                            };
                            obj.valoreAttuale = {
                                options: { classes: 'border-right td-with-number' },
                                value: typeof item.valoreAttuale === 'number' ? item.valoreAttuale.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €' : item.valoreAttuale.replace('.', ',') + ' €'
                            };
                            let linkDettaglio = !_.isNull($('#link-dettaglio')) && $('#link-dettaglio').length ? $('#link-dettaglio').val() + '?rapporto=' + item.codiceRapporto : '';
                            obj.dettaglio = '<a class=\'anchor-link\' href=\'' + linkDettaglio + '\'>Visualizza</a>';
                            return {
                                options: {},
                                value: obj
                            };
                        });

                        ft.rows.load(rows);
                        // let filtering =
                        // FooTable.get('.etica-table-ajax').use(FooTable.Filtering),
                        // // get the filtering component for the table
                        let filter = _this.val(); // get the value to filter by
                        let myParam = {};
                        myParam.name = 'abi';
                        if (filter === 'all') {
                            // if the value is "all" remove the filter
                            // filtering.removeFilter('abi');
                            myParam.value = 'all';
                        } else {
                            // otherwise add/update the filter.
                            // filtering.addFilter('abi', filter, ['abi']);
                            myParam.value = filter;
                        }
                        setQueryParams(myParam);
                        // filtering.filter();
                        $('.overlay-container').addClass('hide-overlay-container');
                    }
                });
            });

            // Manage Filter CAB
            $('body').on('change', '[name=filter_cab]', function () {
                $('.overlay-container').removeClass('hide-overlay-container');

                let ft = FooTable.get('.etica-table-ajax');
                let _this = $(this);
                let myCab = _this.val();
                let myAbi = $('[name=filter_abi]').is('span') ? $('[name=filter_abi]').text() : $('[name=filter_abi]').val();
                $('.btn-reset-filters').prop('disabled', false);
                let urlApi = context_path + '/.rest/api/data/v1/getReports';
                let downloadUrl = context_path + '/.rest/api/download/v1/getRapporti';
                let body = {
                    "abis": myAbi === 'all' ? abis : [myAbi],
                    "cabs": myCab === 'all' ? cabs : [myCab]
                };
                if ($("#export_rapporti_xlsx").length) {
                    $("#export_rapporti_xlsx").attr('href', downloadUrl + '?search=' + encodeURI(JSON.stringify(body)));
                }
                $.ajax({
                	  url:config.rows,
                	  type:"POST",
                	  data:JSON.stringify(body),
                	  contentType:"application/json; charset=utf-8",
                	  dataType:"json",
                	  success: function(data, status){
                          let rows = '';
                          rows = data.map(item => {
                              let obj = {};
                              obj.rapporto = {
                                  options: { classes: 'border-right' },
                                  value: item.codiceRapporto
                              };
                              if (item.abi) {
                                  obj.abi = {
                                      options: { classes: 'border-right' },
                                      value: item.abi
                                  };
                              }
                              obj.cab = {
                                  options: { classes: 'border-right' },
                                  value: item.cab
                              };
                              obj.intestazione = {
                                  options: { classes: 'border-right' },
                                  value: item.intestazione
                              };
                              obj.collocatore = {
                                  options: { classes: 'border-right' },
                                  value: item.collocatore
                              };
                              obj.valoreAttuale = {
                                  options: { classes: 'border-right td-with-number' },
                                  value: typeof item.valoreAttuale === 'number' ? item.valoreAttuale.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €' : item.valoreAttuale.replace('.', ',') + ' €'
                              };

                              let linkDettaglio = !_.isNull($('#link-dettaglio')) && $('#link-dettaglio').length ? $('#link-dettaglio').val() + '?rapporto=' + item.codiceRapporto : '';
                              obj.dettaglio = '<a class=\'anchor-link\' href=\'' + linkDettaglio + '\'>Visualizza</a>';

                              return {
                                  options: {},
                                  value: obj
                              };
                          });

                          ft.rows.load(rows);
                          // let filtering = ft.use(FooTable.Filtering), //
							// get the
      					// filtering component for the table
                          let filter = _this.val(); // get the value to filter
													// by
                          let myParam = {};
                          myParam.name = 'cab';
                          if (filter === 'all') {
                              // if the value is "all" remove the filter
                              // filtering.removeFilter('cab');
                              myParam.value = 'all';
                          } else {
                              // otherwise add/update the filter.
                              // filtering.addFilter('cab', filter, ['cab']);
                              myParam.value = filter;
                          }
                          setQueryParams(myParam);
                          // filtering.filter();
                          $('.overlay-container').addClass('hide-overlay-container');
                	  }
                });
            });

            // Manage Filter Search
            $('[name=filter_search]').on('keyup paste', _.debounce(function (e) {

                $('.overlay-container').removeClass('hide-overlay-container');

                let iconClear = $(this).parent().find('.input-filter-clear');
                let alpha = e.type == 'keyup' && !FooTable.is.emptyString(String.fromCharCode(e.charCode)),
                    ctrl = e.type == 'keyup' && (e.which == 8 || e.which == 46),

                // backspace & delete
                paste = e.type == 'paste';
                if (alpha || ctrl || paste) {
                    if (e.which == 13) e.preventDefault();
                    let query = e.target.value;
                    let filtering = FooTable.get('.etica-table-ajax').use(FooTable.Filtering);
                    if (query.length >= 3) {
                        $('.btn-reset-filters').prop('disabled', false);
                        filtering.addFilter('search', query, config.search);
                        filtering.filter();
                        iconClear.addClass('show');

                        let myParam = {};
                        myParam.name = 'search';
                        myParam.value = query;
                        setQueryParams(myParam);
                    } else {
                        $('.btn-reset-filters').prop('disabled', true);
                        filtering.removeFilter('search');
                        filtering.filter();
                        if (e.which == 8 && query.length < 3) {
                            e.target.value = '';

                            let myParam = {};
                            myParam.name = 'search';
                            deleteQyeryParams(myParam);
                        }
                        iconClear.removeClass('show');
                    }
                }
                $('.overlay-container').addClass('hide-overlay-container');
            }, 300));

            // Clear term searched
            $('[name=filter_search] + .input-filter-clear').on('click', function () {

                let filtering = FooTable.get('.etica-table-ajax').use(FooTable.Filtering);
                filtering.removeFilter('search');
                filtering.filter();
                $('[name=filter_search]').val('');

                let myParam = {};
                myParam.name = 'search';
                deleteQyeryParams(myParam);

                $(this).removeClass('show');
            });

            // Reset filters
            $('.btn-reset-filters').on('click', function () {
                resetFilters();
                $(this).prop('disabled', true);
            });

            */
        }
    }
};

$(document).ready(function () {
    etica.init();
});

function submitDownloadForm(dettagli) {
    console.log('ok');
}
//# sourceMappingURL=main.js.map
